import React from 'react';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';

const Media = ({ className, mediaInfo }) => {
  const { imageUrl, title, description, url, target } = mediaInfo;
  return (
    <Paper
      className={`flex flex-col sm:flex-row md:flex-col xl:flex-row overflow-hidden no-underline
      shadow-lg hover:shadow-xl border border-gray-200 border-solid  hover:border-primary-main  transition duration-300 ease-in-out
      ${className || ''}`}
      component="a"
      href={url}
      target={target}
    >
      <div className="p-3 md:p-5 xl:p-2 bg-gray-200 flex items-center justify-center">
        <img
          className="w-24 h-24 sm:w-20 sm:h-20 md:w-32 md:h-32  xl:w-16 xl:h-16 "
          src={imageUrl}
          alt={`${title} logo`}
        />
      </div>
      <div className="flex-grow p-3 ">
        <h5 className="m-0 mb-1 text-xl font-medium tracking-wider">{title}</h5>
        <p className="text-sm italic font-normal text-gray-500">
          {description}
        </p>
      </div>
    </Paper>
  );
};

Media.propTypes = {
  className: PropTypes.string,
  mediaInfo: PropTypes.object,
};

export default Media;
